import * as Models from "static/js/app/models/__index";
import { FinanceConfig } from "themes/module_finance_plugin/static/js/financeConfig";

export default class finance_checker
{
    public static GetFinanceCheckerUrl( finance_config: FinanceConfig, vehicleSingle: Models.Vehicle) :string
    {       
        if (finance_config != null && finance_config.provider != 'none' && vehicleSingle !=null && vehicleSingle.vehicle_type !== "caravan" && vehicleSingle.finance_quotes != null && vehicleSingle.finance_quotes.length > 0 )
        {
            let quoteId = vehicleSingle.finance_quotes[0].quote_id;
        
           
            switch(finance_config.provider) {
                case "codeweavers":
                    return "";
                case "ivendi":
                    return `https://my.newvehicle.com/start?quoteId=${quoteId}&imageUrl=${finance_checker.GetMainImageUrl(vehicleSingle)}&returnUrl=${window.location.href}`                                              
                default: 
                    return "";
            }
        }
        return "";
    }

    public static SetFinanceCheckerUrl(element: HTMLElement, quoteId: string, imagePath: string = null)
    {
        if (element !=null && quoteId !=null)
        {
            let anchor = element.querySelector("a");
            if (anchor !=null)
            {
                anchor.href= `https://my.newvehicle.com/start?quoteId=${quoteId}&imageUrl=&returnUrl=${window.location.href}`;
            }
            element.classList.remove("invisible");
        }
        else{
            finance_checker.HideFinanceCheckerCTA(element);
        }
       
    }

    public static HideFinanceCheckerCTA(finanacCheckElement: HTMLElement)
    {
        finanacCheckElement.classList.add("invisible");
    }
    

    private static GetMainImageUrl( vehicle: Models.Vehicle)
    {
        return `https://${window.location.host}${vehicle?.main_image?.i850x638 ?? "/awaitingimage.jpg"}`;       
    }
}